// react
import { ReactNode } from 'react';

// mui
import { Box, Divider, Grid, Typography } from '@mui/material';

// theme
import { theme } from '../../../theme';

// ui
import { IconCircle, IconCircleProps } from '../IconCircle/IconCircle';

// props
export interface SectionHeaderProps {
	actions?: ReactNode;
	IconCircleProps: IconCircleProps;
	title: ReactNode;
}

export const SectionHeader = ({ actions, IconCircleProps, title }: SectionHeaderProps) => (
	<Box>
		<Box sx={{ backgroundColor: theme.palette.brand.grey[200], padding: 2 }}>
			<Grid container alignItems="center" spacing={1}>
				<Grid item xs="auto">
					<IconCircle size="sm" {...IconCircleProps} />
				</Grid>
				<Grid item xs="auto">
					<Typography fontWeight={600} component="h2">
						{title}
					</Typography>
				</Grid>
				{actions && (
					<Grid item xs="auto">
						{actions}
					</Grid>
				)}
			</Grid>
		</Box>
		<Divider />
	</Box>
);
